module.exports = __webpack_public_path__ + "static/media/templateShirt.a6b52218.png";